import type { ApplyCouponDto, ApplyCouponResultDto, ClientLookupDto, CouponCheckStatusResultDto, CouponDto, CouponReportDto, CouponReportFilterDto, CouponValidationDto, CouponValidationResultDto, CreateCouponDto, GetCouponsInput, UpdateCouponDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CouponService {
  apiName = 'Default';
  

  apply = (input: ApplyCouponDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ApplyCouponResultDto>({
      method: 'POST',
      url: '/api/app/coupon/apply',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  checkStatus = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, CouponCheckStatusResultDto>({
      method: 'POST',
      url: '/api/app/coupon/check-status',
    },
    { apiName: this.apiName,...config });
  

  create = (input: CreateCouponDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CouponDto>({
      method: 'POST',
      url: '/api/app/coupon',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/coupon/${id}`,
    },
    { apiName: this.apiName,...config });
  

  generateExcel = (input: CouponReportFilterDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'POST',
      responseType: 'blob',
      url: '/api/app/coupon/generate-excel',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CouponDto>({
      method: 'GET',
      url: `/api/app/coupon/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getClientLookup = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ClientLookupDto[]>({
      method: 'GET',
      url: '/api/app/coupon/client-lookup',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetCouponsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CouponDto>>({
      method: 'GET',
      url: '/api/app/coupon',
      params: { filter: input.filter, status: input.status, sommelierId: input.sommelierId, discountType: input.discountType, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getReport = (input: CouponReportFilterDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CouponReportDto[]>({
      method: 'GET',
      url: '/api/app/coupon/report',
      params: { fromDate: input.fromDate, toDate: input.toDate, sommelierId: input.sommelierId, discountType: input.discountType, filter: input.filter },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: UpdateCouponDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CouponDto>({
      method: 'PUT',
      url: `/api/app/coupon/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  validate = (input: CouponValidationDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CouponValidationResultDto>({
      method: 'POST',
      url: '/api/app/coupon/validate',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
